export function prepareCustomAttachment({ message, shared, attType, id }) {
  // For types with links, make sure that user didn't delete the URL if there was one.
  // If they did, they probably didn't want to send it so we shouldn't add an attachment.
  switch (attType) {
    case 'pga-group-event':
      if (message.text.includes(shared)) {
        return {
          type: 'pga_group_event',
          group_event_id: id,
          booking_url: shared,
        }
      } else return null
    case 'pga-lesson-type':
      if (message.text.includes(shared)) {
        return {
          type: 'pga_lesson_type',
          lesson_type_id: id,
          booking_url: shared,
        }
      } else return null
    default:
      return null
  }
}

export const OUR_TYPES = [
  'pga_group_event',
  'pga_lesson_type',
  'note',
  'pga_student_library_upload',
]

export function replaceMentions({ message }) {
  // It replaces the user mentions with the actual user names.

  let messageTextToRender = message.text
  message.mentioned_users.forEach(user => {
    const { id, name } = user
    // replace instances of @id with @name
    messageTextToRender = messageTextToRender.replaceAll(`@${id}`, `@${name}`)
  })

  message.text = messageTextToRender
  return message
}

export const unsupportedWebFormats = [
  'MPEG-4 Visual', // h.263
  'HEVC', // h.265
  'VVC', // h.266
]

export const fileUploadRequestOverride = async (file, channel) => {
  // check if the file is a video and check codec of that video
  const mediaInfoFactory = window?.MediaInfo?.mediaInfoFactory
  const fileName = file.name
  if (file.type === 'video/mp4' && mediaInfoFactory) {
    try {
      const mediaInfo = await mediaInfoFactory()

      const getSize = () => file.size
      const readChunk = async (chunkSize, offset) => {
        const buffer = await file
          .slice(offset, offset + chunkSize)
          .arrayBuffer()
        return new Uint8Array(buffer)
      }

      const result = await mediaInfo.analyzeData(getSize, readChunk)
      if (result.media?.track) {
        const videoTrack = result.media.track.find(
          track => track['@type'] === 'Video',
        )
        if (videoTrack && unsupportedWebFormats.includes(videoTrack.Format)) {
          const codecName = videoTrack.Format || 'Unknown'
          setTimeout(() => {
            const previewers = document.querySelectorAll(
              '.rfu-file-previewer__file',
            )
            const previewer = Array.from(previewers).find(el =>
              el.innerText.includes(fileName),
            )

            if (previewer) {
              previewer.style.flexWrap = 'wrap'

              const warningEl = document.createElement('div')
              warningEl.className = 'codec-warning'
              warningEl.style.color = 'red'
              warningEl.style.fontSize = '12px'
              warningEl.style.marginTop = '8px'
              warningEl.style.display = 'flex'
              warningEl.style.alignItems = 'center'
              warningEl.style.flexBasis = '100%'

              // Create and insert icon using SVG (since we can't directly insert React components)
              const iconSvg = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'svg',
              )
              iconSvg.setAttribute('width', '16')
              iconSvg.setAttribute('height', '16')
              iconSvg.setAttribute('viewBox', '0 0 24 24')
              iconSvg.style.marginRight = '4px'
              iconSvg.style.fill = 'red'

              // This path data represents the WarningOutlined icon
              const path = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path',
              )
              path.setAttribute(
                'd',
                'M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z',
              )

              iconSvg.appendChild(path)
              warningEl.appendChild(iconSvg)

              // Add the text
              const textNode = document.createTextNode(
                `Warning: this video uses the ${codecName} format, which may not play in browsers`,
              )
              warningEl.appendChild(textNode)

              previewer.appendChild(warningEl)
            }
          }, 100)
        }
      }
      mediaInfo.close()
    } catch (error) {
      console.error('Error analyzing file:', error)
    }
  }
  // Use the actual file upload mechanism from Stream Chat
  try {
    const response = await channel.sendFile(file)
    return {
      file: response.file,
    }
  } catch (error) {
    console.error('Error uploading file:', error)
    throw error
  }
}

export const isDistinctChannel = channel => {
  return channel.id && channel.id.startsWith('!members-')
}
